import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import { complexQueryParams } from 'rise-ui/decorators/complex-query-params.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

import { complex, refresh } from 'rise-ui/utils/query-params.js';

@complexQueryParams
@scrollRoot
export default class CatalogIndexRoute extends Route {
  @service ssr;
  @service keywords;
  @service router;
  @service routing;
  @service scrollRoot;
  @service store;
  @service('catalog/search') catalogSearch;

  queryParams = refresh([
    complex('filter'),
    'page',
    'order',
    'search',
  ]);

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: 'Search for data and reports on water, reservoir operations, '
            + 'water quality, hydropower, endangered and invasive species, and more '
            + 'from the Bureau of Reclamation. Use the search and filters to find '
            + 'a variety of data and information, including time series data, '
            + 'geospatial data, tabular data, model data, and reports.',
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            true,
            this.keywords.strings['data-keywords'],
            this.keywords.strings['catalog-keywords'],
          ),
        },
      },
    ];
  }

  model(params) {
    this.catalogSearch.clearEdit().setParams(params);
  }
}
